module.exports = "/_next/static/images/img__form1_left_bottom_desktop.png-614fa1fe32cc63519df10fc3d491e592.png";